import Vue from "vue";
import CharacterNotFoundImage from "@/assets/images/404image.png";
import CharacterPinMapImage from "@/assets/images/character-pin-map.png";

import { Component } from "vue-property-decorator";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";

const NotFoundProps = Vue.extend({
  props: {
    showSearchBar: {
      type: Boolean,
      default: true,
    },
    noNearbyClinics: {
      type: Boolean,
      default: false,
    },
    notFoundPage: {
      type: Boolean,
      default: false,
    },
    noAddress: {
      type: Boolean,
      default: false,
    },
    locationBlocked: {
      type: Boolean,
      default: false,
    },
  },
});

@Component({
  name: "NotFoundPage",
})
export default class NotFoundPage extends NotFoundProps {
  cx_image_NotFound = CharacterNotFoundImage;
  cx_image = CharacterPinMapImage;

  goToServicePage(): void {
    window.location.href = `https://clinicarx.com.br/servicos-clinicos/${this.$route.params.serviceName}/`;
  }

  goToHomePage(): void {
    window.location.href = `https://clinicarx.com.br`;
  }

  allowLocation() {
    GoogleAnalyticsEvents.useLocation();
    this.$emit("changeSearch", true);
  }
}
